import React from "react";

const ActionCancelButton = ({
  text,
  setInvokeModal,
  disabled,
  style,
  Icon,
  ...props
}) => {
  return (
    <button
      className={`px-4 py-[5px] gap-2 rounded border border-[#00394d] text-sm font-semibold text-[#00394d] flex items-center  ${style} ${
        disabled ? "bg-[#aaaaaa] text-white  cursor-default" : ""
      }`}
      {...props}
      disabled={disabled}
    >
      {Icon && <Icon />}
      {text}
    </button>
  );
};

export default ActionCancelButton;
